import { ChevronRight20Regular } from '@/components/Icon'
import { scheduleCadenceLabel, scheduleTimeLabel } from '@/features/schedules/scheduleLabels'
import styles from './HomeNavBrowse.module.scss'

/**
 * One schedule under Updates: the workflow's own title over its cadence.
 * Clicking opens the details panel rather than navigating — one chat can own
 * several schedules, so the row is not a thread.
 */
export default function HomeNavScheduleRow({ workflow, active = false, onSelect }) {
  const time = scheduleTimeLabel(workflow.cron)

  return (
    <button
      type="button"
      className={`${styles.scheduleRow}${active ? ` ${styles.scheduleRowActive}` : ''}`}
      aria-pressed={active}
      onClick={() => onSelect?.(workflow)}
    >
      <span className={styles.scheduleText}>
        <span className={styles.scheduleTitle}>{workflow.title}</span>
        <span className={styles.scheduleCadence}>
          {/* Paused rows keep showing the cadence — it is what resume restores. */}
          {workflow.scheduleEnabled ? null : (
            <span className={styles.schedulePaused}>Paused · </span>
          )}
          {scheduleCadenceLabel(workflow.cron)}
          {time ? ` · ${time}` : ''}
        </span>
      </span>
      <ChevronRight20Regular className={styles.scheduleChevron} aria-hidden />
    </button>
  )
}
